import React, { useState, useEffect } from "react";
import Draggable from "react-draggable";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase";
import Stepper from "./Stepper";
import { doc, getDoc, setDoc } from "firebase/firestore";
import moment from 'moment';
import { formatWarehouse } from '../warehouseTime';
import Modal from "./Modal";
import { Button, ButtonGroup } from "reactstrap";
import History  from './History';
import { isMobile } from 'react-device-detect';
import { v4 as uuidv4 } from 'uuid';

export default function ParkingMap() {
  const [userStatus, setUserStatus] = useState();
  const [placesFromDB, setPlacesFromDB] = useState({});
  const [placesFromDB2, setPlacesFromDB2] = useState({});
  const [placesFromDB3, setPlacesFromDB3] = useState({});
  const [place, setPlace] = useState();
  const [place2, setPlace2] = useState();
  const [place3, setPlace3] = useState();
  const [place4, setPlace4] = useState();
  const [place5, setPlace5] = useState();
  const [place6, setPlace6] = useState();
  const [oldPlace, setOldPlace] = useState();
  const [change, setChange] = useState(false);
  const [positions, setPositions] = useState({}); // Pozycje dla miejsc parkingowych
  const [positions2, setPositions2] = useState({}); // Pozycje dla miejsc parkingowych
  const [positions3, setPositions3] = useState({}); // Pozycje dla miejsc parkingowych
  const [containerNumber, setContainerNumber] = useState();
  const [registrationNumber, setRegistrationNumber] = useState();
  const [open, setOpen] = useState(false);
  const [placeIdInfo, setPlaceIdInfo] = useState();
  const [dateInfo, setDateInfo] = useState();
  const [registrationNumberInfo, setRegistrationNumberInfo] = useState();
  const [containerNumberInfo, setContainerNumberInfo] = useState();
  const [OUT, setOUT] = useState();
  const [parking, setParking] = useState(true);
  const [waitingClick, setWaitingClick] = useState(null);
  const [lastClick, setLastClick] = useState(0);

  const processClick = (e, placeId, date, registrationNumber, containerNumber, OUT) => {
    if(lastClick && e.timeStamp - lastClick < 250 && 
  waitingClick){
      setLastClick(0);
      clearTimeout(waitingClick);
      setWaitingClick(null);
      setOUT(OUT); 
      setOpen(true); 
      setPlaceIdInfo(placeId); 
      setDateInfo(date); 
      setRegistrationNumberInfo(registrationNumber); 
      setContainerNumberInfo(containerNumber)
    }
      else{
        setLastClick(e.timeStamp);
        setWaitingClick(setTimeout(()=>{
        setWaitingClick(null);
        }, 251))
        console.log('single click')        
      }
      
    }
  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserStatus(user.displayName);
      }
    });
  }, []);

  // Funkcja do pobierania danych z Firebase
  const getPlaces = async () => {
    const docRef = doc(db, "takenSeatsIN", "0sdzi0dXHrNHAQona5wc");
    const docRef2 = doc(db, 'unloading', 'DtXcV61obJn7znJwbfP2');
    const docRef3= doc(db, 'takenSeatsOUT', '5aadATVLnDArSFAEi2CA');
    const response = await getDoc(docRef);
    const response2 = await getDoc(docRef2);
    const response3= await getDoc(docRef3);

    if (response.exists() && response2.exists() && response3.exists()) {
      const takenSeats = response.data().takenSeatsIN;
      const unloading = response2.data().unloading;
      const takenSeatsOut = response3.data().takenSeatsOUT;
      const placesObj = {};
      if(takenSeats){
        takenSeats.forEach((takenSeat) => {
          placesObj[takenSeat.place] = {
            date: takenSeat.date,
            containerNumber: takenSeat.containerNumber,
            registrationNumber: takenSeat.registrationNumber,
          };
        });
      }

      const placesObj2 = {};
      if(unloading){
        unloading.forEach((unload) => {
          placesObj2[unload.place] = {
            date: unload.date,
            containerNumber: unload.containerNumber,
            registrationNumber: unload.registrationNumber,
          };
        });
      }

      const placesObj3 = {};
      if(takenSeatsOut){
        takenSeatsOut.forEach((seats) => {
          placesObj3[seats.place] = {
            date: seats.date,
            containerNumber: seats.containerNumber,
            registrationNumber: seats.registrationNumber,
          };
        });
      }

      setPlacesFromDB(placesObj);
      setPlacesFromDB2(placesObj2);
      setPlacesFromDB3(placesObj3);
      
      // Inicjalizuj pozycje miejsc
      const initialPositions = {};
      const initialPositions2 = {};
      const initialPositions3 = {};
      if(takenSeats){
        takenSeats.forEach((takenSeat) => {
          initialPositions[takenSeat.place] = { x: 0, y: 0 }; // Domyślne wartości
        });
      }
      if(unloading){
        unloading.forEach((unload) => {
          initialPositions2[unload.place] = { x: 0, y: 0 }; // Domyślne wartości
        });
      }
      if(takenSeatsOut){
        takenSeatsOut.forEach((seat) => {
          initialPositions3[seat.place] = { x: 0, y: 0 }; // Domyślne wartości
        });
      }
      setPositions(initialPositions);
      setPositions2(initialPositions2);
      setPositions3(initialPositions3);
    }
  };

  useEffect(() => {
    getPlaces(); // Pobierz miejsca na początku
  }, [change]);

  const handleStop4 = async(placeId, e, data) => {
    const originalPosition = positions[placeId]; // Zapisz oryginalną pozycję
  
    if(place){
      const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
      const docRef = doc(db, 'takenSeatsIN', '0sdzi0dXHrNHAQona5wc');
      const docRef2 = doc(db, 'unloading', 'DtXcV61obJn7znJwbfP2');
      const docRef3 = doc(db, "arrivalHistory", "XgVI85U7pm6vLohGrFAU");

      const response = await getDoc(docRef);
      const response2 = await getDoc(docRef2);
      const response3 = await getDoc(docRef3);
      const uuid = uuidv4(); 

      if (response.exists() && response2.exists() && response3.exists()) {
        const takenSeatsIN = response.data().takenSeatsIN;
        const arrivalHistory = response3.data().arrivalHistory;
        const deleteIndex = takenSeatsIN.findIndex((seat) => seat.place === oldPlace);
        takenSeatsIN.splice(deleteIndex, 1);
        const array = [];
  
        const object = {
          status: 'Start of unloading',
          place: place,
          date: date,
          registrationNumber: registrationNumber,
          containerNumber: containerNumber,
          uid: uuid
        }
  
        array.push(object);
        arrivalHistory.push(object);
        const unloading = array.concat(response2.data().unloading);
  
        if(unloading && takenSeatsIN && arrivalHistory){
          setDoc(docRef, {
            takenSeatsIN: takenSeatsIN
          }).then(() => {
            setDoc(docRef2, {
              unloading: unloading
            }).then(() => {
              setDoc(docRef3, {
                arrivalHistory: arrivalHistory
              }).then(() => { setChange(!change); setPlace() })
            })
          })
        }
      }
    }

    if(place3){
      const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
      const docRef = doc(db, 'takenSeatsIN', '0sdzi0dXHrNHAQona5wc');
      const docRef2 = doc(db, "arrivalHistory", "XgVI85U7pm6vLohGrFAU");
      const response = await getDoc(docRef);
      const response2 = await getDoc(docRef2);
      const uuid = uuidv4(); 

      if (response.exists() && response2.exists()) {
        const takenSeatsIN = response.data().takenSeatsIN;
        const arrivalHistory = response.data().arrivalHistory;
        const deleteIndex = takenSeatsIN.findIndex((seat) => seat.place === oldPlace);
        takenSeatsIN.splice(deleteIndex, 1);
  
        const object = {
          status: 'Change of place',
          place: place3,
          date: date,
          registrationNumber: registrationNumber,
          containerNumber: containerNumber,
          uid: uuid
        }
        takenSeatsIN.push(object)
        arrivalHistory.push(object)

        setDoc(docRef, {
          takenSeatsIN: takenSeatsIN
        }).then(() => {
          setDoc(docRef2, {
            arrivalHistory: arrivalHistory
          }).then(() => { setChange(!change); setPlace3() })
        })
      }
    }
  
    // W przeciwnym razie wróć do oryginalnej pozycji
    setPositions((prev) => ({
      ...prev,
      [placeId]: originalPosition, // Przywrócenie oryginalnej pozycji
    }));
  };

  const handleStop4Mobile = async(placeId, e, data, registrationNumberc, containerNumberc) => {
    const originalPosition = positions[placeId]; // Zapisz oryginalną pozycję
    const uuid = uuidv4(); 

    if(place){
      const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
      const docRef = doc(db, 'takenSeatsIN', '0sdzi0dXHrNHAQona5wc');
      const docRef2 = doc(db, 'unloading', 'DtXcV61obJn7znJwbfP2');
      const docRef3 = doc(db, "arrivalHistory", "XgVI85U7pm6vLohGrFAU");

      const response = await getDoc(docRef);
      const response2 = await getDoc(docRef2);
      const response3 = await getDoc(docRef3);

      if (response.exists() && response2.exists() && response3.exists()) {
        const takenSeatsIN = response.data().takenSeatsIN;
        const arrivalHistory = response3.data().arrivalHistory;
        const deleteIndex = takenSeatsIN.findIndex((seat) => seat.place === placeId);
        takenSeatsIN.splice(deleteIndex, 1);
        const array = [];
  
        const object = {
          status: 'Start of unloading',
          place: place,
          date: date,
          registrationNumber: registrationNumberc,
          containerNumber: containerNumberc,
          uid: uuid
        }
  
        array.push(object)
        arrivalHistory.push(object);
        const unloading = array.concat(response2.data().unloading);
  
        if(unloading && takenSeatsIN && arrivalHistory){
          setDoc(docRef, {
            takenSeatsIN: takenSeatsIN
          }).then(() => {
            setDoc(docRef2, {
              unloading: unloading
            }).then(() => {
              setDoc(docRef3, {
                arrivalHistory: arrivalHistory
              }).then(() => { setChange(!change); setPlace() })
            })
          })
        }
      }
    }

    if(place3){
      const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
      const docRef = doc(db, 'takenSeatsIN', '0sdzi0dXHrNHAQona5wc');
      const docRef2 = doc(db, "arrivalHistory", "XgVI85U7pm6vLohGrFAU");

      const response = await getDoc(docRef);
      const response2 = await getDoc(docRef2);

      if (response.exists() && response2.exists()) {
        const takenSeatsIN = response.data().takenSeatsIN;
        const arrivalHistory = response2.data().arrivalHistory;
        const deleteIndex = takenSeatsIN.findIndex((seat) => seat.place === placeId);
        takenSeatsIN.splice(deleteIndex, 1);
  
        const object = {
          status: 'Change of place',
          place: place3,
          date: date,
          registrationNumber: registrationNumberc,
          containerNumber: containerNumberc,
          uid: uuid
        }
        takenSeatsIN.push(object)
        arrivalHistory.push(object)

        setDoc(docRef, {
          takenSeatsIN: takenSeatsIN
        }).then(() => {
          setDoc(docRef2, {
            arrivalHistory: arrivalHistory
          }).then(() => { setChange(!change); setPlace3() })
        })
      }
    }
  
    // W przeciwnym razie wróć do oryginalnej pozycji
    setPositions((prev) => ({
      ...prev,
      [placeId]: originalPosition, // Przywrócenie oryginalnej pozycji
    }));
  };

// Funkcja obsługująca zakończenie przenoszenia
const handleStop = async(placeId, e, data) => {
  const originalPosition = positions[placeId]; // Zapisz oryginalną pozycję
  const uuid = uuidv4(); 

  if(place){
    const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
    const docRef = doc(db, 'takenSeatsIN', '0sdzi0dXHrNHAQona5wc');
    const docRef2 = doc(db, 'unloading', 'DtXcV61obJn7znJwbfP2');
    const docRef3 = doc(db, "arrivalHistory", "XgVI85U7pm6vLohGrFAU");
    const response = await getDoc(docRef);
    const response2 = await getDoc(docRef2);
    const response3 = await getDoc(docRef3);

    if (response.exists() && response2.exists() && response3.exists()) {
      const takenSeatsIN = response.data().takenSeatsIN;
      const deleteIndex = takenSeatsIN.findIndex((seat) => seat.place === oldPlace);
      takenSeatsIN.splice(deleteIndex, 1);
      const array = [];

      const object = {
        status: 'Start of unloading',
        place: place,
        date: date,
        registrationNumber: registrationNumber,
        containerNumber: containerNumber,
        uid: uuid
      }

      array.push(object)
      const unloading = array.concat(response2.data().unloading);
      const arrivalHistory = array.concat(response3.data().arrivalHistory);
      
      if(unloading && takenSeatsIN && arrivalHistory){
        setDoc(docRef, {
        takenSeatsIN: takenSeatsIN
      }).then(() => {
        setDoc(docRef2, {
          unloading: unloading
        })
      }).then(() => {
        setDoc(docRef3, {
          arrivalHistory: arrivalHistory
        }).then(() => { setChange(!change); setPlace() })
      })
    }
    }
  }

  if(place6){
    const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
    const docRef = doc(db, 'takenSeatsIN', '0sdzi0dXHrNHAQona5wc');
    const docRef2 = doc(db, "arrivalHistory", "XgVI85U7pm6vLohGrFAU");

    const response = await getDoc(docRef);
    const response2 = await getDoc(docRef2);

    if (response.exists() && response2.exists()) {
      const takenSeatsIN = response.data().takenSeatsIN;
      const arrivalHistory = response2.data().arrivalHistory;
      const deleteIndex = takenSeatsIN.findIndex((seat) => seat.place === oldPlace);
      takenSeatsIN.splice(deleteIndex, 1);

      const object = {
        status: 'Change of place',
        place: place6,
        date: date,
        registrationNumber: registrationNumber,
        containerNumber: containerNumber,
        uid: uuid
      }
      takenSeatsIN.push(object)
      arrivalHistory.push(object);
      setDoc(docRef, {
        takenSeatsIN: takenSeatsIN
      }).then(() => {
        setDoc(docRef2, {
          arrivalHistory: arrivalHistory
        }).then(() => { setChange(!change); setPlace6() })
      })
    }
  }


  // W przeciwnym razie wróć do oryginalnej pozycji
  setPositions((prev) => ({
    ...prev,
    [placeId]: originalPosition, // Przywrócenie oryginalnej pozycji
  }));
};

  // Funkcja obsługująca zakończenie przenoszenia
  const handleStopMobile = async(placeId, e, data, registrationNumberc, containerNumberc) => {
    const originalPosition = positions[placeId]; // Zapisz oryginalną pozycję
    const uuid = uuidv4(); 

    if(place){
      const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
      const docRef = doc(db, 'takenSeatsIN', '0sdzi0dXHrNHAQona5wc');
      const docRef2 = doc(db, 'unloading', 'DtXcV61obJn7znJwbfP2');
      const docRef3 = doc(db, "arrivalHistory", "XgVI85U7pm6vLohGrFAU");
      const response = await getDoc(docRef);
      const response2 = await getDoc(docRef2);
      const response3 = await getDoc(docRef3);
  
      if (response.exists() && response2.exists() && response3.exists()) {
        const takenSeatsIN = response.data().takenSeatsIN;
        const deleteIndex = takenSeatsIN.findIndex((seat) => seat.place === placeId);
        takenSeatsIN.splice(deleteIndex, 1);
        const array = [];
  
        const object = {
          status: 'Start of unloading',
          place: place,
          date: date,
          registrationNumber: registrationNumberc,
          containerNumber: containerNumberc,
          uid: uuid
        }
  
        array.push(object)
        const unloading = array.concat(response2.data().unloading);
        const arrivalHistory = array.concat(response3.data().arrivalHistory);

        if(unloading && takenSeatsIN && arrivalHistory){
          setDoc(docRef, {
            takenSeatsIN: takenSeatsIN
          }).then(() => {
            setDoc(docRef2, {
              unloading: unloading
            })
          }).then(() => {
            setDoc(docRef3, {
              arrivalHistory: arrivalHistory
            }).then(() => { setChange(!change); setPlace() })
          })
      }
      }
    }

    if(place6){
      const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
      const docRef = doc(db, 'takenSeatsIN', '0sdzi0dXHrNHAQona5wc');
      const docRef2 = doc(db, "arrivalHistory", "XgVI85U7pm6vLohGrFAU");

      const response = await getDoc(docRef);
      const response2 = await getDoc(docRef2);
      const uuid = uuidv4(); 

      if (response.exists() && response2.exists()) {
        const takenSeatsIN = response.data().takenSeatsIN;
        const arrivalHistory = response2.data().arrivalHistory;
        const deleteIndex = takenSeatsIN.findIndex((seat) => seat.place === placeId);
        takenSeatsIN.splice(deleteIndex, 1);
  
        const object = {
          status: 'Change of place',
          place: place6,
          date: date,
          registrationNumber: registrationNumberc,
          containerNumber: containerNumberc,
          uid: uuid
        }
        takenSeatsIN.push(object)
        arrivalHistory.push(object);

        setDoc(docRef, {
          takenSeatsIN: takenSeatsIN
        }).then(() => {
          setDoc(docRef2, {
            arrivalHistory: arrivalHistory
          }).then(() => { setChange(!change); setPlace6() })
        })
      }
    }

    setPositions((prev) => ({
      ...prev,
      [placeId]: originalPosition, // Przywrócenie oryginalnej pozycji
    }));
  }  

const handleStop2 = async(placeId, e, data) => {
  const originalPosition = positions2[placeId]; // Zapisz oryginalną pozycję
  const uuid = uuidv4(); 

  if(place2){
    const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
    const docRef = doc(db, 'unloading', 'DtXcV61obJn7znJwbfP2');
    const docRef2 = doc(db, 'takenSeatsOUT', '5aadATVLnDArSFAEi2CA');
    const docRef3 = doc(db, "departuresHistory", "8N1Nm7FoKCdHgiai3rEM");
    const response = await getDoc(docRef);
    const response2 = await getDoc(docRef2);
    const response3 = await getDoc(docRef3);

    if (response.exists() && response2.exists() && response3.exists()) {
      const unloading = response.data().unloading;
      const departuresHistory = response3.data().departuresHistory;
      const deleteIndex = unloading.findIndex((seat) => seat.place === oldPlace);
      unloading.splice(deleteIndex, 1);
      const array = [];

      const object = {
        status: 'Completion of unloading',
        place: place2,
        date: date,
        registrationNumber: registrationNumber,
        containerNumber: containerNumber,
        uid: uuid
      }

      array.push(object)
      const takenSeatsOUT = array.concat(response2.data().takenSeatsOUT);
      departuresHistory.push(object);

      if(unloading && takenSeatsOUT && departuresHistory){
        setDoc(docRef, {
          unloading: unloading
        }).then(() => {
          setDoc(docRef2, {
            takenSeatsOUT: takenSeatsOUT
          }).then(() => {
            setDoc(docRef3, {
              departuresHistory: departuresHistory
            }).then(() => { setChange(!change); setPlace2() })
          })
        })
      }
    }
  }

  if(place4){
    const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
    const docRef = doc(db, 'unloading', 'DtXcV61obJn7znJwbfP2');
    const docRef2 = doc(db, 'takenSeatsIN', '0sdzi0dXHrNHAQona5wc');
    const docRef3 = doc(db, "arrivalHistory", "XgVI85U7pm6vLohGrFAU");
    const response = await getDoc(docRef);
    const response2 = await getDoc(docRef2);
    const response3 = await getDoc(docRef3);
    const uuid = uuidv4(); 

    if (response.exists() && response2.exists() && response3.exists()) {
      const unloading = response.data().unloading;
      const arrivalHistory = response3.data().arrivalHistory;
      const deleteIndex = unloading.findIndex((seat) => seat.place === oldPlace);
      unloading.splice(deleteIndex, 1);
      const array = [];

      const object = {
        status: 'Unloading correction',
        place: place4,
        date: date,
        registrationNumber: registrationNumber,
        containerNumber: containerNumber,
        uid: uuid
      }

      array.push(object)
      arrivalHistory.push(object)
      const takenSeatsIN = array.concat(response2.data().takenSeatsIN);

      if(unloading && takenSeatsIN && arrivalHistory){
        setDoc(docRef, {
          unloading: unloading
        }).then(() => {
          setDoc(docRef2, {
            takenSeatsIN: takenSeatsIN
          }).then(() => {
            setDoc(docRef3, {
              arrivalHistory: arrivalHistory
            }).then(() => { setChange(!change); setPlace4() })
          })
        })
      }
    }
  }


    if(place6){
      const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
      const docRef = doc(db, 'takenSeatsIN', '0sdzi0dXHrNHAQona5wc');
      const docRef2 = doc(db, 'unloading', 'DtXcV61obJn7znJwbfP2');
      const docRef3 = doc(db, "arrivalHistory", "XgVI85U7pm6vLohGrFAU");
      const response = await getDoc(docRef);
      const response2 = await getDoc(docRef2);
      const response3 = await getDoc(docRef3);
  
      if (response.exists() && response2.exists() && response3.exists()) {
        const takenSeatsIN = response.data().takenSeatsIN;
        const unloading = response2.data().unloading;
        const arrivalHistory = response3.data().arrivalHistory;
        const deleteIndex = unloading.findIndex((seat) => seat.place === oldPlace);
        unloading.splice(deleteIndex, 1);

        const object = {
          status: 'Unloading correction',
          place: place6,
          date: date,
          registrationNumber: registrationNumber,
          containerNumber: containerNumber,
          uid: uuid
        }
        takenSeatsIN.push(object)
        arrivalHistory.push(object)

        if(unloading && takenSeatsIN && arrivalHistory){
          setDoc(docRef2, {
            unloading: unloading
          }).then(() => {
            setDoc(docRef, {
              takenSeatsIN: takenSeatsIN
            }).then(() => {
              setDoc(docRef3, {
                arrivalHistory: arrivalHistory
              }).then(() => { setChange(!change); setPlace6() })
            })
          })
        }
      }
    }

  // W przeciwnym razie wróć do oryginalnej pozycji
  setPositions2((prev) => ({
    ...prev,
    [placeId]: originalPosition, // Przywrócenie oryginalnej pozycji
  }));
};

const handleStop2Mobile = async(placeId, e, data, registrationNumber, containerNumber) => {
  const originalPosition = positions2[placeId]; // Zapisz oryginalną pozycję
  const uuid = uuidv4(); 

  if(place2){
    const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
    const docRef = doc(db, 'unloading', 'DtXcV61obJn7znJwbfP2');
    const docRef2 = doc(db, 'takenSeatsOUT', '5aadATVLnDArSFAEi2CA');
    const docRef3 = doc(db, "departuresHistory", "8N1Nm7FoKCdHgiai3rEM");

    const response = await getDoc(docRef);
    const response2 = await getDoc(docRef2);
    const response3 = await getDoc(docRef3);

    if (response.exists() && response2.exists() && response3.exists()) {
      const unloading = response.data().unloading;
      const departuresHistory = response3.data().departuresHistory;
      const deleteIndex = unloading.findIndex((seat) => seat.place === placeId);
      unloading.splice(deleteIndex, 1);
      const array = [];

      const object = {
        status: 'Completion of unloading',
        place: place2,
        date: date,
        registrationNumber: registrationNumber,
        containerNumber: containerNumber,
        uid: uuid
      }

      array.push(object)
      const takenSeatsOUT = array.concat(response2.data().takenSeatsOUT);
      departuresHistory.push(object);

      if(unloading && takenSeatsOUT && departuresHistory){
        setDoc(docRef, {
          unloading: unloading
        }).then(() => {
          setDoc(docRef2, {
            takenSeatsOUT: takenSeatsOUT
          }).then(() => {
            setDoc(docRef3, {
              departuresHistory: departuresHistory
            }).then(() => { setChange(!change); setPlace2() })
          })
        })
      }
    }
  }

  if(place4){
    const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
    const docRef = doc(db, 'unloading', 'DtXcV61obJn7znJwbfP2');
    const docRef2 = doc(db, 'takenSeatsIN', '0sdzi0dXHrNHAQona5wc');
    const docRef3 = doc(db, "arrivalHistory", "XgVI85U7pm6vLohGrFAU");

    const response = await getDoc(docRef);
    const response2 = await getDoc(docRef2);
    const response3 = await getDoc(docRef3);

    if (response.exists() && response2.exists() && response3.exists()) {
      const unloading = response.data().unloading;
      const deleteIndex = unloading.findIndex((seat) => seat.place === placeId);
      const arrivalHistory = response3.data().arrivalHistory;
      unloading.splice(deleteIndex, 1);
      const array = [];

      const object = {
        status: 'Unloading correction',
        place: place4,
        date: date,
        registrationNumber: registrationNumber,
        containerNumber: containerNumber,
        uid: uuid
      }

      array.push(object)
      arrivalHistory.push(object)
      const takenSeatsIN = array.concat(response2.data().takenSeatsIN);

      if(unloading && takenSeatsIN && arrivalHistory){
        setDoc(docRef, {
          unloading: unloading
        }).then(() => {
          setDoc(docRef2, {
            takenSeatsIN: takenSeatsIN
          }).then(() => {
            setDoc(docRef3, {
              arrivalHistory: arrivalHistory
            }).then(() => { setChange(!change); setPlace4() })
          })
        })
      }
    }
  }


    if(place6){
      const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
      const docRef = doc(db, 'takenSeatsIN', '0sdzi0dXHrNHAQona5wc');
      const docRef2 = doc(db, 'unloading', 'DtXcV61obJn7znJwbfP2');
      const docRef3 = doc(db, "arrivalHistory", "XgVI85U7pm6vLohGrFAU");

      const response = await getDoc(docRef);
      const response2 = await getDoc(docRef2);
      const response3 = await getDoc(docRef3);
  
      if (response.exists() && response2.exists() && response3.exists()) {
        const takenSeatsIN = response.data().takenSeatsIN;
        const unloading = response2.data().unloading;
        const arrivalHistory = response3.data().arrivalHistory;
        const deleteIndex = unloading.findIndex((seat) => seat.place === placeId);
        unloading.splice(deleteIndex, 1);

        const object = {
          status: 'Unloading correction',
          place: place6,
          date: date,
          registrationNumber: registrationNumber,
          containerNumber: containerNumber,
          uid: uuid
        }
        takenSeatsIN.push(object)
        arrivalHistory.push(object)

        if(unloading && takenSeatsIN && arrivalHistory){
          setDoc(docRef2, {
            unloading: unloading
          }).then(() => {
            setDoc(docRef, {
              takenSeatsIN: takenSeatsIN
            }).then(() => {
              setDoc(docRef3, {
                arrivalHistory: arrivalHistory
              }).then(() => { setChange(!change); setPlace6() })
            })
          })
        }
      }
    }

  // W przeciwnym razie wróć do oryginalnej pozycji
  setPositions2((prev) => ({
    ...prev,
    [placeId]: originalPosition, // Przywrócenie oryginalnej pozycji
  }));
};

const handleStop3 = async(placeId, e, data) => {
  const originalPosition = positions3[placeId]; // Zapisz oryginalną pozycję

  // if(place){
  //   const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
  //   const docRef = doc(db, 'unloading', 'DtXcV61obJn7znJwbfP2');
  //   const docRef2 = doc(db, 'takenSeatsOUT', '5aadATVLnDArSFAEi2CA');
  //   const response = await getDoc(docRef);
  //   const response2 = await getDoc(docRef2);

  //   if (response.exists() && response2.exists()) {
  //     const unloading = response.data().unloading;
  //     const deleteIndex = unloading.findIndex((seat) => seat.place === oldPlace);
  //     unloading.splice(deleteIndex, 1);
  //     const array = [];

  //     const object = {
  //       place: place,
  //       date: date,
  //       registrationNumber: registrationNumber,
  //       containerNumber: containerNumber
  //     }

  //     array.push(object)
  //     const takenSeatsOUT = array.concat(response2.data().takenSeatsOUT);

  //     setDoc(docRef, {
  //       unloading: unloading
  //     }).then(() => {
  //       setDoc(docRef2, {
  //         takenSeatsOUT: takenSeatsOUT
  //       })
  //     }).then(() => window.location.reload())
  //   }
  // }
  const uuid = uuidv4(); 

  if(place5){
    console.log('working')
    const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
    const docRef = doc(db, 'unloading', 'DtXcV61obJn7znJwbfP2');
    const docRef2 = doc(db, 'takenSeatsOUT', '5aadATVLnDArSFAEi2CA');
    const docRef3 = doc(db, "departuresHistory", "8N1Nm7FoKCdHgiai3rEM");
    const response = await getDoc(docRef);
    const response2 = await getDoc(docRef2);
    const response3 = await getDoc(docRef3);

    if (response.exists() && response2.exists() && response3.exists()) {
      const takenSeatsOUT = response2.data().takenSeatsOUT;
      const departuresHistory = response3.data().departuresHistory;
      const deleteIndex = takenSeatsOUT.findIndex((seat) => seat.place === placeId);
      takenSeatsOUT.splice(deleteIndex, 1);
      const array = [];

      const object = {
        status: 'Restoration of the unloading site',
        place: place5,
        date: date,
        registrationNumber: registrationNumber,
        containerNumber: containerNumber,
        uid: uuid
      }

      array.push(object)
      departuresHistory.push(object)
      const unloading = array.concat(response.data().unloading);

      if(unloading && takenSeatsOUT && departuresHistory){
        setDoc(docRef, {
          unloading: unloading
        }).then(() => {
          setDoc(docRef2, {
            takenSeatsOUT: takenSeatsOUT
          }).then(() => {
            setDoc(docRef3, {
              departuresHistory: departuresHistory
            }).then(() => { setChange(!change); setPlace5() })
          })
        })
      }
    }
  }

  // W przeciwnym razie wróć do oryginalnej pozycji
  setPositions3((prev) => ({
    ...prev,
    [placeId]: originalPosition, // Przywrócenie oryginalnej pozycji
  }));
};

const handleStop3Mobile = async(placeId, e, data, registrationNumber, containerNumber) => {
  const originalPosition = positions3[placeId]; // Zapisz oryginalną pozycję

  // if(place){
  //   const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
  //   const docRef = doc(db, 'unloading', 'DtXcV61obJn7znJwbfP2');
  //   const docRef2 = doc(db, 'takenSeatsOUT', '5aadATVLnDArSFAEi2CA');
  //   const response = await getDoc(docRef);
  //   const response2 = await getDoc(docRef2);

  //   if (response.exists() && response2.exists()) {
  //     const unloading = response.data().unloading;
  //     const deleteIndex = unloading.findIndex((seat) => seat.place === oldPlace);
  //     unloading.splice(deleteIndex, 1);
  //     const array = [];

  //     const object = {
  //       place: place,
  //       date: date,
  //       registrationNumber: registrationNumber,
  //       containerNumber: containerNumber
  //     }

  //     array.push(object)
  //     const takenSeatsOUT = array.concat(response2.data().takenSeatsOUT);

  //     setDoc(docRef, {
  //       unloading: unloading
  //     }).then(() => {
  //       setDoc(docRef2, {
  //         takenSeatsOUT: takenSeatsOUT
  //       })
  //     }).then(() => window.location.reload())
  //   }
  // }
  const uuid = uuidv4(); 

  if(place5){
    const date = formatWarehouse(new Date(), 'yyyy-MM-dd HH:mm:ss');
    const docRef = doc(db, 'unloading', 'DtXcV61obJn7znJwbfP2');
    const docRef2 = doc(db, 'takenSeatsOUT', '5aadATVLnDArSFAEi2CA');
    const docRef3 = doc(db, "departuresHistory", "8N1Nm7FoKCdHgiai3rEM");

    const response = await getDoc(docRef);
    const response2 = await getDoc(docRef2);
    const response3 = await getDoc(docRef3);

    if (response.exists() && response2.exists() && response3.exists()) {
      const takenSeatsOUT = response2.data().takenSeatsOUT;
      const deleteIndex = takenSeatsOUT.findIndex((seat) => seat.place === placeId);
      const departuresHistory = response3.data().departuresHistory;
      takenSeatsOUT.splice(deleteIndex, 1);
      const array = [];

      const object = {
        status: 'Restoration of the unloading site',
        place: place5,
        date: date,
        registrationNumber: registrationNumber,
        containerNumber: containerNumber,
        uid: uuid
      }

      array.push(object)
      departuresHistory.push(object)
      const unloading = array.concat(response.data().unloading);

      if(unloading && takenSeatsOUT && departuresHistory){
        setDoc(docRef, {
          unloading: unloading
        }).then(() => {
          setDoc(docRef2, {
            takenSeatsOUT: takenSeatsOUT
          }).then(() => {
            setDoc(docRef3, {
              departuresHistory: departuresHistory
            }).then(() => { setChange(!change); setPlace5() })
          })
        })
      }
    }
  }

  // W przeciwnym razie wróć do oryginalnej pozycji
  setPositions3((prev) => ({
    ...prev,
    [placeId]: originalPosition, // Przywrócenie oryginalnej pozycji
  }));
};

const handleDrag = (placeData, placeId) => {
  if (!isMobile) {
      setContainerNumber(placeData.containerNumber); 
      setOldPlace(placeId); 
      setRegistrationNumber(placeData.registrationNumber)
  }
  // Dla urządzeń mobilnych nie robimy nic lub możesz tu dodać inną logikę
};


const renderPlace = (placeId) => {
  const placeData = placesFromDB[placeId];

  const parkingSpace = (
    <div className={`parking-space ${placeData ? "seated-db-schelter" : "free"}`}>
      <div onMouseEnter={() => { setPlace3(placeId); setPlace4(placeId) }} onMouseLeave={() => { setPlace3(); setPlace4() }} onPointerEnter={() => { setPlace3(placeId); setPlace4(placeId) }} onPointerLeave={() => { setPlace3(); setPlace4() }} className="parking-space-2">
      {placeId}
      {placeData && (
        <>
          <br />
          {placeData.date} <br />
          {placeData.containerNumber}
        </>
      )}
      </div>
    </div>
  );
  const parkingSpace2 = (
    <div onClick={(e) => { processClick(e, placeId, placeData.date, placeData.registrationNumber, placeData.containerNumber, false) }} className={`parking-space ${placeData ? "seated-db-schelter" : "free"}`}>
      {placeId}
      {placeData && (
        <>
          <br />
          {placeData.date} <br />
          {placeData.containerNumber}
        </>
      )}
    </div>
  );

  return placeData ? (
    <Draggable
      key={placeId}
      position={positions[placeId]} // Przekaż pozycję
      onStop={(e, data) => handleStop(placeId, e, data)} // Obsługa zatrzymania
      onMouseDown={(e, data) => handleStopMobile(placeId, e, data, placeData.registrationNumber, placeData.containerNumber)}
      onDrag={(e) => handleDrag(placeData, placeId)}
      disabled={isMobile ? true : false}
    >
      {parkingSpace2}
    </Draggable>
  ) : (
    parkingSpace
  );
};

useEffect(() => {
  const parking_space = document.querySelectorAll('.parking-space');
  if(isMobile && parking_space){
    Array.from(parking_space).forEach((space) => {
      if(space.children[0]){
        if(space.children[0].tagName === 'DIV'){
          if(place === space.children[0].innerHTML || place2 === space.children[0].innerHTML || place3 === space.children[0].innerHTML || place4 === space.children[0].innerHTML || place5 === space.children[0].innerHTML || place6 === space.children[0].innerHTML){
            space.classList.add('active-space');
          }else{
            space.classList.remove('active-space');
          }
        }
      }

    })
  }
}, [place, place2, place3, place4, place5, place6])

const renderPlace2 = (placeId) => {
  const placeData = placesFromDB2[placeId];

  const parkingSpace = (
    <div className={`parking-space ${placeData ? "seated-db-schelter" : "free"}`}>
    <div onMouseEnter={() => { setPlace(placeId); setPlace5(placeId) } } onMouseLeave={() => { setPlace(); setPlace5() }} onPointerEnter={() => { setPlace(placeId); setPlace5(placeId) }} onPointerLeave={() => { setPlace(); setPlace5() }} className="parking-space-2">
      {placeId}
      {placeData && (
        <>
          <br />
          {placeData.date} <br />
          {placeData.containerNumber}
        </>
      )}
    </div>
    </div>
  );

  const parkingSpace2 = (
    <div onClick={(e) => { processClick(e, placeId, placeData.date, placeData.registrationNumber, placeData.containerNumber, false) }} className={`parking-space ${placeData ? "seated-db-schelter" : "free"}`}>
      {placeId}
      {placeData && (
        <>
          <br />
          {placeData.date} <br />
          {placeData.containerNumber}
        </>
      )}
    </div>
  );

  return placeData ? (
    <Draggable
      key={placeId}
      position={positions2[placeId]} // Przekaż pozycję
      onStop={(e, data) => handleStop2(placeId, e, data)} // Obsługa zatrzymania
      onMouseDown={(e, data) => handleStop2Mobile(placeId, e, data, placeData.registrationNumber, placeData.containerNumber)} // Obsługa zatrzymania
      onDrag={(e) => handleDrag(placeData, placeId)}
      disabled={isMobile ? true : false}
    >
      {parkingSpace2}
    </Draggable>
  ) : (
    parkingSpace 
  );
};

const renderPlace3 = (placeId) => {
  const placeData = placesFromDB3[placeId];

  const parkingSpace = (
    <div className={`parking-space ${placeData ? "seated-db-schelter" : "free"}`}>
    <div onMouseEnter={() => setPlace2(placeId)} onMouseLeave={() => setPlace2()} onPointerEnter={() => setPlace2()} onPointerLeave={() => setPlace2()} className="parking-space-2">
      {placeId}
      {placeData && (
        <>
          <br />
          {placeData.date} <br/>
          {placeData.containerNumber}
        </>
      )}
    </div>
    </div>
  );

  const parkingSpace2 = (
    <div onClick={(e) => { processClick(e, placeId, placeData.date, placeData.registrationNumber, placeData.containerNumber, true) }} className={`parking-space ${placeData ? "seated-db-schelter" : "free"}`}>
      {placeId}
      {placeData && (
        <>
          <br />
          {placeData.date} <br/>
          {placeData.containerNumber}
        </>
      )}
    </div>
  );

  return placeData ? (
    <Draggable
      key={placeId}
      position={positions3[placeId]} // Przekaż pozycję
      onStop={(e, data) => isMobile ? '' : handleStop3(placeId, e, data)} // Obsługa zatrzymania
      onDrag={(e) => handleDrag(placeData, placeId)}
      onMouseDown={(e, data) => handleStop3Mobile(placeId, e, data, placeData.registrationNumber, placeData.containerNumber)}
      disabled={isMobile ? true : false}
    >
      {parkingSpace2}
    </Draggable>
  ) : (
    parkingSpace 
  );
};

const renderPlace4 = (placeId) => {
  const placeData = placesFromDB[placeId];

  const parkingSpace = (
    <div className={`parking-space ${placeData ? "seated-db-schelter" : "free"}`}>
      <div onMouseEnter={() => setPlace6(placeId)} onMouseLeave={() => setPlace6()} onPointerEnter={() => setPlace6(placeId)}  onPointerLeave={() => setPlace6()} className="parking-space-2">
      {placeId}
      {placeData && (
        <>
          <br />
          {placeData.date} <br />
          {placeData.containerNumber}
        </>
      )}
      </div>
    </div>
  );
  

  const parkingSpace2 = (
    <div onClick={(e) => { processClick(e, placeId, placeData.date, placeData.registrationNumber, placeData.containerNumber, false) }} className={`parking-space ${placeData ? "seated-db-schelter" : "free"}`}>
      {placeId}
      {placeData && (
        <>
          <br />
          {placeData.date} <br />
          {placeData.containerNumber}
        </>
      )}
    </div>
  );

  return placeData ? (
    <Draggable
      key={placeId}
      position={positions[placeId]} // Przekaż pozycję
      onDrag={(e) => handleDrag(placeData, placeId)}
      onStop={(e, data) => handleStop4(placeId, e, data)} // Obsługa zatrzymania
      onMouseDown={(e, data) => handleStop4Mobile(placeId, e, data, placeData.registrationNumber, placeData.containerNumber)}
      disabled={isMobile ? true : false}
    >
      {parkingSpace2}
    </Draggable>
  ) : (
    parkingSpace
  );
};

const btn_1 = document.querySelector('.btn-12');
const btn_2 = document.querySelector('.btn-22');

useEffect(() => {
  if(parking && btn_1 && btn_2){
    btn_1.classList.add('btn-active');
    btn_2.classList.remove('btn-active');
  }else if(!parking && btn_1 && btn_2){
    btn_2.classList.add('btn-active');
    btn_1.classList.remove('btn-active');
  }
}, [parking, btn_1, btn_2])


  return (
    <>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN" crossorigin="anonymous"></link>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
        rel="stylesheet"
        integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN"
        crossOrigin="anonymous"
      />
      <Modal setChange={setChange} change={change} OUT={OUT} open={open} setOpen={setOpen} placeIdInfo={placeIdInfo} dateInfo={dateInfo} registrationNumberInfo={registrationNumberInfo} containerNumberInfo={containerNumberInfo} />

      {parking ? userStatus === "manager" || userStatus === "superadmin" || userStatus === "shunter" ? (
        <div className="content" id="content" style={{ display: "flex", flexFlow: "column nowrap" }}>
          <ButtonGroup id='btn-group' style={{ width: '50%', marginLeft: 'auto', marginRight: 'auto' }}>
            <Button className="button btn-12" onClick={() => setParking(true)}>Parking Map</Button>
            <Button className="button btn-22" onClick={() => setParking(false)}>History</Button>
          </ButtonGroup>
        <div style={{ display: "flex", flexFlow: "row nowrap", minHeight: 'calc(100vh - 123px)', marginTop: '3rem' }}>
          <div className="grid-container w-full">
            <div className="grid-item">              
            </div>
            {/* Miejsca parkingowe */}
            <div className="grid-item">
              {renderPlace3("18A")}
              {renderPlace3("17A")}
              {renderPlace3("16A")}
              {renderPlace3("15A")}
              {renderPlace3("18B")}
              {renderPlace3("17B")}
              {renderPlace3("16B")}
              {renderPlace3("15B")}
            </div>

            <div className="grid-item"></div>

            <div className="grid-item">
              <p className='parking-description'>ARRIVALS</p>
              {renderPlace("14A")}
              {renderPlace("14B")}
              {renderPlace("13A")}
              {renderPlace("13B")}
              {renderPlace("12A")}
              {renderPlace("12B")}
              {renderPlace("11A")}
              {renderPlace("11B")}
              {renderPlace("10A")}
              {renderPlace("10B")}
              {renderPlace("9A")}
              {renderPlace("9B")}
              {renderPlace("8A")}
              {renderPlace("8B")}
              {renderPlace("7A")}
              {renderPlace("7B")}
              {renderPlace("6A")}
              {renderPlace("6B")}
              {renderPlace("5A")}
              {renderPlace("5B")}
              <div></div>
              {renderPlace("4")}
              <div></div>
              {renderPlace("3")}
              <div></div>
              {renderPlace("2")}
              <div></div>
              {renderPlace("1")}
            </div>
            <div className="grid-item"></div>

            <div className="grid-item">
            <p className='parking-description'>EMERGENCY PARKING</p>
              {renderPlace4("35A")}
              {renderPlace4("35B")}
              {renderPlace4("34A")}
              {renderPlace4("34B")}
              {renderPlace4("33A")}
              {renderPlace4("33B")}
              {renderPlace4("32A")}
              {renderPlace4("32B")}
              {renderPlace4("31A")}
              {renderPlace4("31B")}
              {renderPlace4("30A")}
              {renderPlace4("30B")}
              {renderPlace4("29A")}
              {renderPlace4("29B")}
              {renderPlace4("28A")}
              {renderPlace4("28B")}
              {renderPlace4("27A")}
              {renderPlace4("27B")}
              {renderPlace4("26A")}
              {renderPlace4("26B")}
            </div>

            <div className="grid-item">
              <p className='parking-description-2'>DEPARTURES</p>
              {renderPlace3("19A")}
              {renderPlace3("19B")}
              {renderPlace3("20A")}
              {renderPlace3("20B")}
              {renderPlace3("21A")}
              {renderPlace3("21B")}
              {renderPlace3("22A")}
              {renderPlace3("22B")}
              {renderPlace3("23A")}
              {renderPlace3("23B")}
              {renderPlace3("24A")}
              {renderPlace3("24B")}
              {renderPlace3("25A")}
              {renderPlace3("25B")}
            </div>

            <div className="grid-item">
              <div className='grid-position'>
                <p className='parking-description'>UNLOADING</p>
                {renderPlace2("X1")}
                {renderPlace2("X2")}
                {renderPlace2("XUR3")}
                {renderPlace2("KPO1")}
                {renderPlace2("LCJ2")}
                {renderPlace2("WROM")}
                {renderPlace2("DHL1")}
                {renderPlace2("DHL2")}
              </div>
            </div>
            <div className="grid-item"></div>
            <div className="grid-item"></div>
            </div>
          </div>
          <div className="legend">
            <div className="legend-flex"><div className="circle-1"></div><p>empty place</p></div>
            {isMobile ? <div className="legend-flex"><div className="circle-3"></div><p>selected place</p></div> : ''}
            <div className="legend-flex"><div className="circle-2"></div><p>occupied place</p></div>
          </div>
        </div>
      ) : (
        <div className="content" id="content" style={{ display: "flex", flexFlow: "column nowrap", alignItems: "start" }}>
          <Stepper />
        </div>
      ) : <div className="content" id="content" style={{ display: "flex", flexFlow: "column nowrap", alignItems: "start" }}>
          <ButtonGroup id='btn-group' style={{ width: '50%', marginLeft: 'auto', marginRight: 'auto' }}>
            <Button className="button btn-12" onClick={() => setParking(true)}>Parking Map</Button>
            <Button className="button btn-22" onClick={() => setParking(false)}>History</Button>
          </ButtonGroup>
          <History />
          </div>}
    </>
  );
}